import React, {useState} from 'react';
import { ApiService } from '../Axios/ApiService';

const useProductInfoModal = (productId) => {

    const [modal, setModal] = useState({
        show: false,
        content: "",
        loading: false
    });
    
    const onOpenModal = async optionName => {
        try {
            setModal({
                loading: true,
                show: true,
                content: ""
            });
            const res = await ApiService.get(
                `/bestellen/optioninfo/${productId}/${optionName}`
            );
            const data = res.data;
            setModal({
                loading: false,
                show: true,
                content: data
            });
        } catch (e) {
            console.log(e.message)
            throw e
        }
    };

    const onCloseModal = () => {
        setModal({
            loading: false,
            show: false,
            content: ""
        });
    };

    return {
        modal,
        onOpenModal,
        onCloseModal
    }
};

export default useProductInfoModal;